import { createAction, props } from "@ngrx/store";
import {
  CursorLocation,
  Expression,
  GlobalSearchMatch,
} from "../category-builder.models";

export const resetWorkingCategory = createAction(
  "[WorkingCategory] Reset Working Category",
);

export const setWorkingCategory = createAction(
  "[WorkingCategory] Set Working Category",
  props<{ categoryID: string; readOnly: boolean }>(),
);

export const setSandbox = createAction(
  "[WorkingCategory] Set Sandbox",
  props<{ sandbox: Expression }>(),
);

export const resetSandbox = createAction("[WorkingCategory] Reset Sandbox");

export const setAnimateDeltaModeIcons = createAction(
  "[WorkingCategory] Toggle Animate Delta Mode Icons",
  props<{ animate: boolean }>(),
);

export const setDeltaOriginalExpression = createAction(
  "[WorkingCategory] Set Delta Original Expression",
  props<{ deltaOriginalExpression: Expression }>(),
);

export const setDeltaExpressions = createAction(
  "[WorkingCategory] Set Delta Expression",
  props<{ deltaCurrentExpression: Expression }>(),
);

export const resetDeltaMode = createAction(
  "[WorkingCategory] Reset Delta Mode State",
);

export const setUncategorizedCategory = createAction(
  "[WorkingCategory] Set UncategorizedCategory",
  props<{ uncategorized: Expression }>(),
);

export const setExpandedGroups = createAction(
  "[WorkingCategory] Set Expand Groups",
  props<{ expandedGroups: { [groupId: string]: boolean } }>(),
);

export const resetExpandedGroups = createAction(
  "[WorkingCategory] Reset Expanded Groups",
);

export const setGroupExpansions = createAction(
  "[WorkingCategory] Set Group Expansions",
  props<{ groupExpansions: { [groupId: string]: boolean } }>(),
);

export const setCursorLocation = createAction(
  "[WorkingCategory] Set Cursor Location",
  props<{ cursorLocation: CursorLocation }>(),
);

export const setGlobalSearchMatches = createAction(
  "[WorkingCategory] Set Global Search Matches",
  props<{ globalSearchMatches: GlobalSearchMatch[] }>(),
);
